module.exports = __webpack_public_path__ + "static/fabric-datepicker-basic-b8b4a8aae533c83d1994470de6e5a8ed.gif";